module.exports = __webpack_public_path__ + "img/wl_code_1.cf540eb3.png";